/**
 * AiDisclosureNotice
 * ------------------
 * Gemensam, återanvändbar systemnotis som informerar besökaren om att
 * chatten drivs av AI. Placeras direkt under chat-headern och OVANFÖR
 * det första chattmeddelandet. Notisen är avsiktligt diskret — den
 * är varken en del av headern eller en chattbubbla.
 *
 * Anpassa aldrig texten här per kund; alla Elido-chattar ska ha samma
 * formulering enligt AI-transparenskravet.
 */
import { Info } from "lucide-react";

export function AiDisclosureNotice({ className = "" }) {
  return (
    <div
      role="note"
      aria-label="AI-notis"
      data-testid="ai-disclosure-notice"
      className={
        "mx-3 mt-3 mb-2 flex items-start gap-2 rounded-lg " +
        "bg-[#EEF3F7] border border-slate-200 px-3 py-2 " +
        "text-[12.5px] leading-snug text-slate-700 " +
        className
      }
    >
      <Info
        className="w-3.5 h-3.5 mt-[2px] text-slate-500 shrink-0"
        aria-hidden="true"
      />
      <span>Den här chatten använder AI för att svara på dina frågor.</span>
    </div>
  );
}

export default AiDisclosureNotice;
